/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * @brief Common class for base store
     */
    var StoreBase = /** @class */ (function () {
        function StoreBase(changedEvent) {
            this.changedEvent = changedEvent || "DefaultChangeEvent";
            this.handlers = {};
        }
        /**
         * @brief This method returns an unique key for the store. The same will be used in StoreManager to store in the Dictionary
         */
        StoreBase.getKey = function () {
            throw new Error("This method needs to be implemented in derived classes");
        };
        /**
         * @brief Initializes the store
         */
        StoreBase.prototype.initialize = function (instanceId) {
            this._instanceId = instanceId || "";
        };
        /**
         * @brief Returns the instanceId
         */
        StoreBase.prototype.getInstanceId = function () {
            return this._instanceId;
        };
        /**
         * @brief Returns the state information preserved in store
         */
        StoreBase.prototype.getState = function () {
            return {};
        };
        StoreBase.prototype.addChangedListener = function (handler) {
            this.addListener(this.changedEvent, handler);
        };
        StoreBase.prototype.removeChangedListener = function (handler) {
            this.removeListener(this.changedEvent, handler);
        };
        StoreBase.prototype.addListener = function (eventName, handler) {
            if (!this.handlers[eventName]) {
                this.handlers[eventName] = [];
            }
            this.handlers[eventName].push(handler);
        };
        StoreBase.prototype.removeListener = function (eventName, handler) {
            if (this.handlers[eventName]) {
                for (var handlerIndex = this.handlers[eventName].length - 1; handlerIndex >= 0; handlerIndex--) {
                    if (this.handlers[eventName][handlerIndex] === handler) {
                        this.handlers[eventName].splice(handlerIndex, 1);
                    }
                }
            }
        };
        StoreBase.prototype.emitChanged = function () {
            this.emit(this.changedEvent, this);
        };
        StoreBase.prototype.emit = function (eventName, sender) {
            if (this.handlers[eventName]) {
                for (var _i = 0, _a = this.handlers[eventName]; _i < _a.length; _i++) {
                    var handler = _a[_i];
                    handler(sender);
                }
            }
        };
        StoreBase.prototype._dispose = function () {
            this.disposeInternal();
            this._instanceId = null;
        };
        return StoreBase;
    }());
    exports.StoreBase = StoreBase;
});
